import React, { createContext, useContext, useState } from 'react';

const WorkflowContext = createContext();

export const useWorkflowContext = () => useContext(WorkflowContext);

export const WorkflowProvider = ({ children }) => {
  const [workflowData, setWorkflowData] = useState({
    nodes: [
      {
        id: '1',
        type: 'initialNode',
        nodeType: 12,
        position: {
          x: 200,
          y: 300,
        },
        is_Error: true,
      },
    ],
    edges: [],
  });
  const [selectedNode, setSelectedNode] = useState(null);
  const [disableDrag, setDisableDrag] = useState(true);
  const [isChanged, setIsChanged] = useState([]);
  const [initialWorkflowData, setInitialWorkflowData] = useState([]);
  const [type, setType] = useState(null);

  const resetWorkflowData = () => {
    setWorkflowData({
      nodes: [
        {
          id: '1',
          type: 'initialNode',
          nodeType: 12,
          position: {
            x: 200,
            y: 300,
          },
          is_Error: true,
        },
      ],
      edges: [],
    });
  };

  return (
    <WorkflowContext.Provider
      value={{
        workflowData,
        setWorkflowData,
        selectedNode,
        setSelectedNode,
        disableDrag,
        setDisableDrag,
        resetWorkflowData,
        isChanged,
        setIsChanged,
        initialWorkflowData,
        setInitialWorkflowData,
        type,
        setType,
      }}
    >
      {children}
    </WorkflowContext.Provider>
  );
};
